var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedClosePlaceOrderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.42.42a1.428 1.428 0 012.022 0L10 7.98 17.56.42a1.43 1.43 0 012.022 2.022L12.02 10l7.561 7.559a1.43 1.43 0 11-2.022 2.022L10 12.02 2.442 19.58A1.429 1.429 0 11.42 17.56L7.98 10 .42 2.442A1.428 1.428 0 01.42.42z",
    fill: "#182341"
  })));
}
export default SvgLedClosePlaceOrderIcon;